export default "__VITE_ASSET__9bb86d0d__"